/* Homepage Plus-promo (sections/home-plus-promo.liquid, 04-10-2026).
   Speelt de video zonder geluid af zodra hij voor de helft in beeld is en pauzeert hem daarbuiten. De video's
   staan op preload="none" zonder autoplay-attribuut: alleen de zichtbare variant (breed op desktop, vierkant op
   mobiel) laadt, want de andere staat op display:none en komt nooit in beeld. Zet de bezoeker de video zelf
   stil, dan start dit script hem niet opnieuw. Bij prefers-reduced-motion of zonder IntersectionObserver doet
   het niets: dan blijft de poster staan en speelt de video alleen via de knoppen. Geen meting, geen opslag. */
(function (g) {
  'use strict';
  var d = g.document;
  if (!d || typeof d.querySelectorAll !== 'function') return;
  var videos = d.querySelectorAll('[data-plus-promo-video] video');
  if (!videos.length) return;
  var rustig = typeof g.matchMedia === 'function' && g.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (rustig || !('IntersectionObserver' in g)) return;

  var io = new g.IntersectionObserver(function (items) {
    items.forEach(function (it) {
      var v = it.target;
      v.__vcInBeeld = it.isIntersecting && it.intersectionRatio >= 0.5;
      if (v.__vcInBeeld) {
        if (v.__vcGestopt || !v.paused) return;
        v.muted = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else if (!v.paused) {
        v.__vcZelf = true;
        v.pause();
      }
    });
  }, {threshold: [0, 0.5]});

  Array.prototype.forEach.call(videos, function (v) {
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.addEventListener('pause', function () {
      // Stilgezet terwijl hij in beeld is en niet door dit script: dat deed de bezoeker.
      if (!v.__vcZelf && v.__vcInBeeld) v.__vcGestopt = true;
      v.__vcZelf = false;
    });
    v.addEventListener('play', function () { v.__vcGestopt = false; });
    io.observe(v);
  });
})(typeof window !== 'undefined' ? window : this);
